import { BASE_URL, absoluteUrl } from '../../components/SEO';
import { eventImageOrDefault } from '../../utils/imageUrl';

export const seoPath = (data) => {
  if (data.commune && data.category) return `/panoramas/${data.commune.slug}/${data.category.slug}`;
  if (data.commune) return `/panoramas/${data.commune.slug}`;
  return `/categoria/${data.category.slug}`;
};

export const seoHeading = (data) => {
  if (data.commune && data.category) return `${data.category.name} en ${data.commune.name}`;
  if (data.commune) return `Panoramas en ${data.commune.name}`;
  return `${data.category.name}: panoramas en Chile`;
};

export const seoTitle = (data) => {
  if (data.commune && data.category) return `${data.category.name} en ${data.commune.name}: próximos eventos`;
  if (data.commune) return `Panoramas en ${data.commune.name}: eventos y actividades`;
  return `${data.category.name} en Chile: próximos eventos`;
};

export const seoBreadcrumbs = (data) => {
  const crumbs = [{ name: 'Inicio', path: '/' }];
  if (data.commune) crumbs.push({ name: `Panoramas en ${data.commune.name}`, path: `/panoramas/${data.commune.slug}` });
  if (data.category) crumbs.push({ name: data.category.name, path: seoPath(data) });
  return crumbs;
};

export const buildSeoJsonLd = (data) => {
  const url = BASE_URL + seoPath(data);
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        '@id': url,
        url,
        name: seoHeading(data),
        description: data.intro,
        inLanguage: 'es-CL',
      },
      {
        '@type': 'ItemList',
        name: seoHeading(data),
        numberOfItems: data.events.length,
        itemListElement: data.events.map((ev, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          url: `${BASE_URL}/event/${ev.id}`,
          name: ev.name,
          image: absoluteUrl(eventImageOrDefault(ev.main_image)),
        })),
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: seoBreadcrumbs(data).map((c, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: c.name,
          item: BASE_URL + c.path,
        })),
      },
    ],
  };
};
